import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './contexts/CartContext'; // ÚJ: Importáljuk a CartProvider-t

// Az index.html SEO-alapértékei (data-default-seo) a JS-t nem futtató botoknak szólnak; a böngészőben
// az oldalak Helmet-címkéi veszik át a helyüket, különben minden oldalon két leírás / og:title lenne,
// és az első mindig az általános főoldali szöveg.
document.querySelectorAll('[data-default-seo]').forEach((el) => el.remove());
// Helmet nélküli oldalakra (pl. bejelentkezés) maradjon általános cím
document.title = 'Wedigo | Az esküvőd itt kezdődik';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* ÚJ: A CartProvider-rel vesszük körbe az alkalmazást */}
    <CartProvider>
      <App />
    </CartProvider>
  </React.StrictMode>
);

reportWebVitals();